export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 72;
export const PASSWORD_ALLOWED_SYMBOLS = "!@#$%^&*()_+-=[]{};':\"\\|<>?,./`~";

export const PASSWORD_RULES = [
  { key: 'minLength', label: `At least ${PASSWORD_MIN_LENGTH} characters` },
  { key: 'lowercase', label: 'One lowercase letter' },
  { key: 'uppercase', label: 'One uppercase letter' },
  { key: 'number', label: 'One number' },
  { key: 'symbol', label: 'One symbol' },
];

export function checkPasswordRules(password) {
  const value = password || '';
  return {
    minLength: value.length >= PASSWORD_MIN_LENGTH,
    lowercase: /[a-z]/.test(value),
    uppercase: /[A-Z]/.test(value),
    number: /[0-9]/.test(value),
    symbol: [...value].some((ch) => PASSWORD_ALLOWED_SYMBOLS.includes(ch)),
    maxLength: value.length <= PASSWORD_MAX_LENGTH,
  };
}

export function isPasswordValid(password) {
  const results = checkPasswordRules(password);
  return Object.values(results).every(Boolean);
}
